import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router";
import { ApiError, authApi } from "../lib/api";
import { useAuth } from "../lib/auth";

export function SignupPage() {
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const { user } = await authApi.signup(email, password, displayName);
      setUser(user);
      navigate("/stories", { replace: true });
    } catch (err) {
      if (err instanceof ApiError) {
        setError(err.issues?.map((i) => i.message).join(" ") || err.message);
      } else {
        setError("Something went wrong");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="page-center">
      <form className="card auth-card" onSubmit={onSubmit}>
        <h1 className="brand">Story AI</h1>
        <p className="muted">Create an account to build and play stories.</p>

        <label className="field">
          <span>Display name</span>
          <input
            type="text"
            autoComplete="nickname"
            required
            maxLength={80}
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
          />
        </label>
        <label className="field">
          <span>Email</span>
          <input
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label className="field">
          <span>Password</span>
          <input
            type="password"
            autoComplete="new-password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span className="muted small">At least 8 characters</span>
        </label>

        {error && <div className="error">{error}</div>}

        <button type="submit" className="btn btn-primary" disabled={busy}>
          {busy ? "Creating…" : "Create account"}
        </button>
        <p className="muted small">
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </form>
    </div>
  );
}
